import type { ShopperSearch } from '@/scapi';

type ProductSearchHit = ShopperSearch.schemas['ProductSearchHit'];

function isProductSearchHit(value: unknown): value is ProductSearchHit {
    return typeof value === 'object' && value !== null && typeof (value as ProductSearchHit).productId === 'string';
}

/** Keeps auth URLs small: only the selected SKU and display name are needed to resume the wishlist action. */
export function buildAddToWishlistActionParams(
    product: ProductSearchHit,
    variant?: ProductSearchHit
): Record<string, unknown> {
    const productId = variant?.productId || product.productId;
    if (!productId) {
        return {};
    }

    return {
        productId,
        productName: product.productName,
    };
}

/** Restores the product passed through pending addToWishlist action params. */
export function resolvePendingWishlistProduct(params: Record<string, unknown>): {
    product: ProductSearchHit;
    variant?: ProductSearchHit;
} {
    const product = isProductSearchHit(params.product)
        ? params.product
        : ({
              productId: String(params.productId ?? ''),
              productName: String(params.productName ?? ''),
          } as ProductSearchHit);

    const variant = isProductSearchHit(params.variant) ? params.variant : undefined;

    return { product, variant };
}
